"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendHook = exports.fetcher = void 0;
var use_customer_1 = __importDefault(require("./commerce/use-customer"));
var url = process.env.BIGCOMMERCE_STOREFRONT_API_URL;
var token = process.env.BIGCOMMERCE_STOREFRONT_API_TOKEN_GRAPHQL;
var REGION = process.env.NEXT_PUBLIC_REGION;
var defaultOpts = {
    url: 'https://hellomamma-sp-sandbox.mybigcommerce.com/graphql',
    method: 'POST',
    credentials: 'include',
};
var getLoggedInCustomerQuery = /* GraphQL */ "\n  query getLoggedInCustomer {\n    customer {\n      entityId\n      firstName\n      lastName\n      email\n      company\n      customerGroupId\n      notes\n      phone\n      addressCount\n      attributeCount\n      storeCredit {\n        value\n        currencyCode\n      }\n      attributes {\n        attribute(entityId: 3) {\n          value\n        }\n      }\n    }\n  }\n";
var getLoggedInCustomerQueryES = /* GraphQL */ "\n  query getLoggedInCustomer {\n    customer {\n      entityId\n      firstName\n      lastName\n      email\n      company\n      customerGroupId\n      notes\n      phone\n      addressCount\n      attributeCount\n      storeCredit {\n        value\n        currencyCode\n      }\n      attributes {\n        attribute(entityId: 12) {\n          value\n        }\n      }\n    }\n  }\n";
var fetcher = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, data;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Authorization': "Bearer ".concat(token),
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        query: REGION === 'ES' ? getLoggedInCustomerQueryES : getLoggedInCustomerQuery,
                    }),
                })];
            case 1:
                res = _m.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                data = _m.sent();
                if (!((_c = (_b = (_a = data.data) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.attribute.value)) return [3 /*break*/, 4];
                return [4 /*yield*/, fetch('/api/bigcommerce/persistent', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            action: 'check_carts',
                            cart_id: (_e = (_d = data.data) === null || _d === void 0 ? void 0 : _d.customer.attributes) === null || _e === void 0 ? void 0 : _e.attribute.value,
                            user_id: (_f = data.data) === null || _f === void 0 ? void 0 : _f.customer.entityId
                        })
                    })];
            case 3:
                _m.sent();
                return [3 /*break*/, 6];
            case 4:
                if (!((_g = data.data) === null || _g === void 0 ? void 0 : _g.customer)) return [3 /*break*/, 6];
                return [4 /*yield*/, fetch('/api/bigcommerce/persistent', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            action: 'set_attribute',
                            user_id: (_h = data.data) === null || _h === void 0 ? void 0 : _h.customer.entityId
                        })
                    })];
            case 5:
                _m.sent();
                localStorage.setItem('userCustomer', JSON.stringify((_j = data.data) === null || _j === void 0 ? void 0 : _j.customer.firstName));
                _m.label = 6;
            case 6: return [2 /*return*/, (_l = (_k = data.data) === null || _k === void 0 ? void 0 : _k.customer) !== null && _l !== void 0 ? _l : null];
        }
    });
}); };
exports.fetcher = fetcher;
function extendHook(customFetcher, swrOptions) {
    var useCustomer = function () {
        return (0, use_customer_1.default)(defaultOpts, [], customFetcher, __assign({ revalidateOnFocus: false }, swrOptions));
    };
    useCustomer.extend = extendHook;
    return useCustomer;
}
exports.extendHook = extendHook;
exports.default = extendHook(exports.fetcher);
